import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "account_icon",
  "use": "account_icon-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" id=\"account_icon\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\"><path d=\"M19.8 11a4.2 4.2 0 11-.001 8.401A4.2 4.2 0 0119.8 11zM12 29a7.8 7.8 0 1115.6 0\" /><path d=\"M16.8 21.8v.6a3 3 0 006 0v-.6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol